import { render, staticRenderFns } from "./QueueChart.vue?vue&type=template&id=4cb5e052&scoped=true"
import script from "./QueueChart.vue?vue&type=script&lang=js"
export * from "./QueueChart.vue?vue&type=script&lang=js"
import style0 from "./QueueChart.vue?vue&type=style&index=0&id=4cb5e052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb5e052",
  null
  
)

export default component.exports